import React  from "react";
import { SignatureContext } from "../provider/signature";
import { Text, View } from "react-native";
import useStyles from "./styles.css";

const MailContent = () => {
  const styles = useStyles();
  const { document } = React.useContext(SignatureContext);

  return (
    <View>
      <Text style={[styles.body2, { marginTop: 20}]}>
        <Text style={styles.body2_bold}>Email Subject: </Text> 
        {document?.workflow?.emailContent?.subject}
      </Text>
      {document?.workflow?.emailContent?.message ? (
        <Text style={[styles.body2, { marginTop: 20}]}> 
          <Text style={styles.body2_bold}>Message: </Text> 
          {document.workflow.emailContent.message}
        </Text>
      ) : null}
    </View>
  );
};

export default React.memo(MailContent);
